<div>
	<button class="btn btn-default btn-sm ng-scope" type="button">
		<div class="inline">Add </div>
		<!--?xml version="1.0" encoding="UTF-8" standalone="no"?-->
		<svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink">
			<!-- Generator: Sketch 3.7.2 (28276) - http://www.bohemiancoding.com/sketch -->
			<title>cha-plus</title>
			<desc>Created with Sketch.</desc>
			<defs></defs>
			<g id="64px-Line" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="cha-plus"></g>
				<path d="M31,6 C16.112,6 4,18.112 4,33 C4,47.888 16.112,60 31,60 C45.888,60 58,47.888 58,33 C58,18.112 45.888,6 31,6 L31,6 Z M31,58 C17.215,58 6,46.785 6,33 C6,19.215 17.215,8 31,8 C44.785,8 56,19.215 56,33 C56,46.785 44.785,58 31,58 L31,58 Z" id="Shape" fill="#000000"></path>
				<path d="M45,32 L32,32 L32,19 C32,18.448 31.552,18 31,18 C30.448,18 30,18.448 30,19 L30,32 L17,32 C16.448,32 16,32.448 16,33 C16,33.552 16.448,34 17,34 L30,34 L30,47 C30,47.552 30.448,48 31,48 C31.552,48 32,47.552 32,47 L32,34 L45,34 C45.552,34 46,33.552 46,33 C46,32.448 45.552,32 45,32 L45,32 Z" id="Shape" fill="#000000"></path>
			</g>
		</svg>
	</button>
</div>